import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import pluralize from 'pluralize';
import React from 'react';
import { IMPACT_PERCEPTION } from '../../../../lib/schema.js';
import { useWindowSize } from '../../../../lib/utils.js';

export const ImpactPerceptionChart = (props) => {
  const { results, textProps, renderLabel, piePerceptionRef } = props;

  const colors = [
    'var(--color--pale-teal)',
    'var(--color--marigold)',
    'var(--color--faded-red)',
  ];

  const size = useWindowSize();

  const resultsByPerception = IMPACT_PERCEPTION.map((type) => [
    ...results.filter((item) => item.perception === type),
  ]).filter((result) => result.length);

  const data = resultsByPerception.map((arr) => ({
    name: arr[0].perception,
    value: Math.round((arr.length / results.length) * 100),
    count: arr.length,
  }));

  const height = data.length / 0.2 + 350;

  const getCellColor = (entry) => {
    if (entry.name === 'Negative') {
      return colors[2];
    }
    if (entry.name === 'Positive') {
      return colors[0];
    }
    return colors[1];
  };

  return (
    <div ref={piePerceptionRef}>
      <ResponsiveContainer
        id="impact-perception-chart-container"
        height={height}
      >
        <PieChart>
          <text {...textProps} x="50%" y="50%" fontSize={28}>
            {results.length}
          </text>
          <text {...textProps} x="50%" y="50%" dy="20">
            {pluralize('Impact', results.length)}
          </text>
          <Pie
            data={data}
            dataKey="count"
            innerRadius={size.width > 1400 ? 60 : 45}
            outerRadius={size.width > 1400 ? 90 : 60}
            isAnimationActive={false}
            startAngle={90}
            endAngle={-270}
            label={renderLabel}
            labelLine={false}
          >
            {data.map((entry, index) => {
              return (
                <Cell key={index} fill={getCellColor(entry)} stroke="none" />
              );
            })}
          </Pie>
          {data.map((entry, index) => {
            return (
              <Tooltip
                key={index}
                contentStyle={{
                  background: 'var(--color--light-pale-grey)',
                  borderColor: 'var(--color--silver)',
                  borderRadius: 4,
                  padding: '4px 10px',
                }}
                itemStyle={{ color: 'var(--color--dark-blue-grey)' }}
                separator=" &bull; "
              />
            );
          })}
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
